module.exports = __webpack_public_path__ + "img/ic_airmoney_pay.fd03e6b.svg";